// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__2kMvr","CardSection":"Card_CardSection__1TDR5","CardBox":"Card_CardBox__1ME2E"};